/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CarHistoryCarInfoFromJSON, CarHistoryCarInfoToJSON, ServiceActionHistoryDtoFromJSON, } from './';
export function CarHistoryReportDtoFromJSON(json) {
    return CarHistoryReportDtoFromJSONTyped(json, false);
}
export function CarHistoryReportDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'reportId': !exists(json, 'reportId') ? undefined : json['reportId'],
        'reportNumber': !exists(json, 'reportNumber') ? undefined : json['reportNumber'],
        'carInfo': !exists(json, 'carInfo') ? undefined : CarHistoryCarInfoFromJSON(json['carInfo']),
        'serviceActions': !exists(json, 'serviceActions') ? undefined : (json['serviceActions'] === null ? null : json['serviceActions'].map(ServiceActionHistoryDtoFromJSON)),
    };
}
export function CarHistoryReportDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'carInfo': CarHistoryCarInfoToJSON(value.carInfo),
    };
}
